import { defineStore } from 'pinia';
import { reactive, toRefs } from 'vue';

export interface AvatarState {
  avatars: Record<string, number>;
}

export const useAvatarStore = defineStore('avatar', () => {
  const state = reactive<AvatarState>({
    avatars: {},
  });

  // migrated mutations
  const setAvatar = (id: string) => {
    state.avatars[id] = new Date().getTime();
  };

  return {
    ...toRefs(state),
    setAvatar,
  };
});

export default useAvatarStore;
